import script from "./LoginPageSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPageSection.vue?vue&type=script&setup=true&lang=js"

import "./LoginPageSection.vue?vue&type=style&index=0&id=46810b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46810b6e"]])

export default __exports__